<template>
  <v-dialog v-model="userChatOptions.isCustomPanelOpen" persistent scrollable fullscreen>
    <v-flex xs12 class="pa-2" fill-height>
      <v-card class="rounded-light" color="blue-grey lighten-5" min-height="400">
        <v-toolbar dark dense color="blue darken-4">
          <v-toolbar-title class="white--text">Discovered startups</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closePanel()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <!--<v-layout row wrap ma-2 justify-center>
            <v-flex xs4>
                <SelectImageChooser :options="jobStatusOptions"
                                    :currentSelection="selectedJobStatus"
                                    :items="availableJobStatus">
                </SelectImageChooser>
            </v-flex>
        </v-layout>-->
        <v-layout row wrap v-if="startups.length>0">
          <v-flex xs12>
            <v-btn color="success" @click="downloadCsv">Download</v-btn>
            <span class="subheading">Download here the report (CSV file with </span>
            <span class="subheading" style="color:red; font-weight: bold;">TAB separator</span>
            <span class="subheading">)</span>
          </v-flex>

          <v-flex v-for="market in markets" xs12>
            <v-layout row wrap>
              <v-flex xs4>
                <v-card v-if="(market !== '-') && (market !== 'None')" color="blue-grey darken-2" class="white--text">
                  <v-card-title primary-title>
                    <div class="subheading" style="font-weight: bold;">Market {{ market }}</div>
                  </v-card-title>
                </v-card>
                <v-card v-else color="blue-grey darken-2" class="white--text">
                  <v-card-title primary-title>
                    <div class="subheading" style="font-weight: bold;">Market Not Available</div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex v-for="startup in startups"
                      v-if="startup['Addressed MU'].includes(market) || (startup['Addressed MU'] === 'None' && market === '-')"
                      xs12 sm6 md6 lg4 xl4>
                <v-card class="ma-2">
                  <v-layout row wrap align-center class="ma-0 pa-0">
                    <v-flex xs12>
                      <v-card-title class="subheading ma-2 pa-0">
                        <v-layout row wrap align-center class="ma-0 pa-0">
                          <v-flex grow><strong>{{ startup.Name }}</strong>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="startup.show = !startup.show">
                            <v-icon>{{ startup.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <Divider></Divider>
                  <v-card-text v-show="startup.show">
                    <v-flex xs12 v-for="value, key in startup">
                      <v-flex
                          v-if="!(key==='Idea description-IT' && userSettings.chatbot.language.current.locale==='en' || key==='Idea description-EN' && userSettings.chatbot.language.current.locale==='it' || key==='show')">
                        <v-layout row wrap mx-3>
                          <v-flex grow>
                            <strong>{{ getKey(key) }}</strong>
                          </v-flex>
                          <v-flex
                              v-if="(key === 'Link to folder in Peers' || key === 'UrlVideo' || key === 'Website' || key === 'Contact links' || key === 'Logo' || key === 'Crunchbase link') && value !== 'None' && value !== '' && value !== '-'"
                              shrink>
                            <a :href="value" target="_blank">link</a>
                          </v-flex>
                          <v-flex v-else shrink>
                            <span style="word-break: break-all">{{ value }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
        <v-layout v-else>
          <v-flex class="mt-5 pt-5 text-xs-center title">{{ noStartupsFound }}</v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-dialog>
</template>


<script>
import {mapGetters, mapState} from "vuex";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";
import SelectImageChooser from "../Inputs/SelectImageChooser";
import Divider from "../Decorator/Divider";

export default {
  name: "ChatbotPanel",
  components: {Divider, SelectImageChooser},
  computed: {
    ...mapState({}),
    ...mapGetters("ChatbotState", {
          userChatOptions: "getUserChatOptions"
        }
    ),
    ...mapGetters("UserState", {
      userSettings: "getSettings",
      userOptions: "getUserOptions"
    }),
  },
  watch: {
    "userChatOptions.isCustomPanelOpen": {
      handler: function (value, newValue) {
        if (newValue === false) {
          this.getStartups();
        }
      }
    }
  },
  data() {
    return {
      noStartupsFound: "",
      startups: [],
      markets: [],
      startupsCsv: []
    };
  },
  created() {

  },
  methods: {
    /*convertToCSV(objArray) {
        let csv = '';
        let header = Object.keys(objArray[0]).join(',');
        let values = objArray.map(o => Object.values(o).join(',')).join('\n');

        csv += header + '\n' + values;
        console.log(csv)
    },*/
    downloadCsv() {
      let blob = new Blob([this.startupsCsv], {type: 'text/csv;charset=utf-8;'});
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "startups.csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    },
    openPanel() {
      return this.openChatbotPanel;
    },
    closePanel() {
      this.userChatOptions.isCustomPanelOpen = false;
      this.$store.dispatch("ChatbotState/setUserChatOptions", this.userChatOptions);
    },
    getKey(key) {
      if (key === "Idea description-IT" || key === "Idea description-EN") {
        return "Idea description";
      } else if (key === "Addressed MU") {
        return "Addressed market";
      } else if (key === 'Contact links')
        return "Company LinkedIn URL";
      else {
        return key;
      }
    },
    convertToCSV(objArray) {
      let csv = "";
      if (objArray.length > 0) {
        for (let i = 0; i < objArray.length; i++) {
          let keys = Object.keys(objArray[i]);
          for (let j = 0; j < keys.length; j++) {
            let key = keys[j];
            if (typeof objArray[i][key] === "string") {
              objArray[i][key] = objArray[i][key].replace(new RegExp("\n", "g"), " ")
              objArray[i][key] = objArray[i][key].replace(new RegExp(";", "g"), ",")
            }
          }

        }

        let header = Object.keys(objArray[0]).join('\t');
        let values = objArray.map(o => Object.values(o).join('\t')).join('\n');
        csv += header + '\n' + values;
      }
      return csv;
    },
    decodeHtml(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    getStartups() {
      this.noStartupsFound = "";
      this.startups = [];
      this.markets = [];
      let requestUrl = {
        url: UrlsService.getStartupResults,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: this.userOptions.contextId
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData
        },
      };
      let messages = {
        title: "Get retrieved startups",
        loading: "Loading",
        error: "Server Error",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let response = responseSuccess;
            let st = response.response.startups;
            let containCross = false;
            let containNotAvailableDash = false;
            let containNotAvailableNone = false;
            this.startupsCsv = this.convertToCSV(st);
            if (st.length === 0) {
              this.noStartupsFound = "No startups found."
            } else {
              for (let i = 0; i < st.length; i++) {
                st[i]["Idea description-EN"] = this.decodeHtml(st[i]["Idea description-EN"])
                st[i]["Idea description-IT"] = this.decodeHtml(st[i]["Idea description-IT"])
                st[i].show = false;
                this.startups.push(st[i])

                //get all unique market in result to show in a filtered way
                for (const market of st[i]["Addressed MU"]) {
                  if (!this.markets.includes(market) && market !== "Cross" && market !== "-" && market !== "None") {
                    this.markets.push(market)
                  }
                  if (market === "Cross") {
                    containCross = true
                  }
                  if (market === "-") {
                    containNotAvailableDash = true
                  }
                  if (market === "None") {
                    containNotAvailableNone = true
                  }
                }
              }
              this.markets.sort()
              if (containCross) this.markets.push("Cross") //Push "Cross" only at the end of the array for a better visualization, push "Cross" only if necessary
              if (containNotAvailableDash || containNotAvailableNone) this.markets.push("-") //Push "-" only at the end of the array for a better visualization, push "-" only if necessary
            }

          });
    }
  },
};
</script>
<style lang="scss">

</style>
